import EventEmitter from 'eventemitter3';

export const eventEmitter = new EventEmitter();

/**
 * Emitter object facades for EventEmitter instance
 *
 * @type       {Object}
 */
const Emitter = {
  /**
   * Registers an event only once, and avoids multiple execution
   *
   * @param      {String}    event   The event
   * @param      {Function}  fn      The function
   */
  register: (event, fn, context) => {
    if (!eventEmitter.eventNames().includes(event)) {
      eventEmitter.on(event, fn, context)
    }
  },
  on: (event, fn, context) => eventEmitter.on(event, fn, context),
  once: (event, fn, context) => eventEmitter.once(event, fn, context),
  off: (event, fn, context) => eventEmitter.off(event, fn, context),
  emit: (event, payload) => {
    eventEmitter.emit(event, payload);

    /**
     * ENHANCEMENTS V2 2023:
     * - CUSTOM ADDITIONAL EVENT NAME EXTENSION SHOULD BE CALLED/INVOKED
     *   DYNAMICALLY AS LONG AS THE FIRST STRING PART IS ALMOST THE SAME OF THE
     *   ORIGINAL EVENT NAME
     *
     * - PURPOSE: SO WE CAN ADD A SERIES OF EVENT NAMES THAT ARE UNIQUE WITH
     *   EACH OTHER BUT RELATIVELY ASSOCIATED FROM THE ORIGINAL, WHEN THE
     *   ORIGINAL GETS INVOKED, OTHER CUSTOM COPY SHOULD BE INVOKED AS WELL.
     *   - listen-me ( original )
     *   - listen-me-another-me ( extension )
     *   - listen-me-from-somewhere ( extension )
     *   - listen-me-example ( extension )
     *   * ALL EXTENSIONS WILL BE INVOKED AS WELL WHEN INVOKING THE 'listen-me' EVENT
     *
     * - REASON: THIS SOLVES THE EMITTER.OFF, APPARENTLY FROM PREVIOUS VERSION 1
     *   2021, WE CANNOT USE EMITTER.OFF TO UNREGISTER AN EVENT LISTENER WHEN FROM
     *   A COMPONENT IS ABOUT TO BE UNMOUNTED, BECAUSE ON OLDER VERSION WHEN WE
     *   USE THE EMITTER.OFF, ALL OF THE LISTENERS WITH THE SAME NAME GET'S
     *   DISABLED/UNREGISTERED AS WELL, THIS IS A PROBLEM IF YOU HAVE MULTIPLE
     *   LISTENERS AND YET NOT EVERY COMPONENT GETS MOUNTED EVERYTIME AT THE
     *   SAME TIME
     *
     * - BEHAVIOUR:
     *   <code>
     *     Emitter.register('listen-me', (payload) => {
     *        console.log('listen-me', payload);
     *     });
     *     Emitter.on('listen-me' + '-another-me', (payload) => {
     *        console.log('listen-me-another-me', payload);
     *     });
     *
     *     Emitter.emit('listen-me', {test: '123'});
     *   </code>
     *
     *  - OUTPUT:
     *    <code>
     *      * listen-me, { test: '123' }
     *      * listen-me-another-me, { test: '123' }
     *    </code>
     */
    let extension_events = eventEmitter
      .eventNames()
      .filter(name => name.includes(event) && name !==  event);

      /**
       * IMPLEMENTATION BUGFIX:
       * - Since we have an '-after' extension name now, we need to make sure we
       *   avoid callign those '-after' events if the main event name does not
       *   contains it
       */
    extension_events = extension_events.filter(name => {
        if (event.includes('-after')) {
          return 1;
        } else {
          return !name.includes('-after')
        }
      });

    for (var i = 0; i < extension_events.length; i++) {
      eventEmitter.emit(extension_events[i], payload);
    }
  }
}

Object.freeze(Emitter);

export default Emitter;